import Backbone from 'backbone';

module.exports = Backbone.Model.extend({
  defaults: {
    code: '',
    name: '',
    is_active: true,
    is_shared: false,
    is_donation: false,
    opening_balance: 0,
    budget: 0,
    unit_cost: 0,
    groups:[],
    new_group: ''
  }
});


// WEBPACK FOOTER //
// ./receipt/models/account.js